<template>
    <div class="settings-view" v-loading="page.loading">
        <div class="row">
            <div class="col-md-12">
                <el-form ref="settingForm" :model="page.form" :rules="page.formRules" label-width="150px">
                    <div v-if="rights.information">
                        <p>Contact Information</p>

                        <el-form-item label="Address 1" prop="address1">
                            <vue-editor v-model="page.form.address1" ref="content" :editorToolbar="customToolbar" ></vue-editor>
                        </el-form-item>

                        <el-form-item label="Address 2" prop="address2">
                            <vue-editor v-model="page.form.address2" ref="content" :editorToolbar="customToolbar" ></vue-editor>
                        </el-form-item>

                        <el-form-item label="MAP URL" prop="mapURL">
                            <el-input type="textarea" v-model="page.form.mapURL" ref="mapURL"></el-input>
                        </el-form-item>

                        <el-form-item label="Mobile 1" prop="mobile1">
                            <el-input v-model="page.form.mobile1" ref="mobile1"></el-input>
                        </el-form-item>

                        <el-form-item label="Mobile 2" prop="mobile2">
                            <el-input v-model="page.form.mobile2" ref="mobile2"></el-input>
                        </el-form-item>

                        <el-form-item label="Email 1" prop="email1">
                            <el-input v-model="page.form.email1" ref="email1"></el-input>
                        </el-form-item>

                        <el-form-item label="Email 2" prop="email2">
                            <el-input v-model="page.form.email2" ref="email2"></el-input>
                        </el-form-item>
                    </div>

                    <div v-if="rights.bankDetails">
                        <p>Bank Details</p>

                        <el-form-item label="Account Name" prop="accountName">
                            <el-input v-model="page.form.accountName" ref="accountName"></el-input>
                        </el-form-item>

                        <el-form-item label="Name of Bank" prop="nameOfBank">
                            <el-input v-model="page.form.nameOfBank" ref="nameOfBank"></el-input>
                        </el-form-item>

                        <el-form-item label="Branch" prop="branch">
                            <el-input v-model="page.form.branch" ref="branch"></el-input>
                        </el-form-item>

                        <el-form-item label="Account Number" prop="accountNummber">
                            <el-input v-model="page.form.accountNummber" ref="accountNummber"></el-input>
                        </el-form-item>

                        <el-form-item label="IFSC" prop="ifsc">
                            <el-input v-model="page.form.ifsc" ref="ifsc"></el-input>
                        </el-form-item>
                    </div>


                    <div v-if="rights.socialMediaURL">
                        <p>Social Media URLs:</p>

                        <el-form-item label="Facebook URL" prop="facebookURL">
                            <el-input v-model="page.form.facebookURL" ref="facebookURL"></el-input>
                        </el-form-item>

                        <el-form-item label="Instagram URL" prop="instagramURL">
                            <el-input v-model="page.form.instagramURL" ref="instagramURL"></el-input>
                        </el-form-item>

                        <el-form-item label="Tiwtter URL" prop="tiwtterURL">
                            <el-input v-model="page.form.tiwtterURL" ref="tiwtterURL"></el-input>
                        </el-form-item>

                        <el-form-item label="Youtube URL" prop="youtubeURL">
                            <el-input v-model="page.form.youtubeURL" ref="youtubeURL"></el-input>
                        </el-form-item>
                    </div>

                    
                     <el-form-item>
                        <el-button :loading="page.updateBtnLoad" @click="setData" type="primary">Update</el-button>
                    </el-form-item>
                    


                </el-form>
            </div>
        </div>
    </div>
</template>

<script>
import {generateHeader} from "@/misc/function.js";
import { VueEditor } from "vue2-editor";
export default {
    components: {
        VueEditor
    },
    data () {
        return {
            customToolbar: [["bold", "italic", "underline"], [{ list: "ordered" }, { list: "bullet" }]],
            rights:{
                page: true,
                information: false,
                bankDetails: false,
                socialMediaURL: false
            },
            page: {
                loading: true,
                updateBtnLoad: false,
                form: {
                    // URL
                    facebookURL: '',
                    instagramURL: '',
                    tiwtterURL: '',
                    youtubeURL: '',

                    // Bank Details
                    accountName: '',
                    nameOfBank: '',
                    branch: '',
                    accountNummber: '',
                    ifsc: '',

                    //Website Info
                    address1: '',
                    address2: '',
                    mobile1: '',
                    mobile2: '',
                    email1: '',
                    email2: '',
                    mapURL: '',
                }
            }
        }
    },
    methods: {
            getRights() {
                this.loading = true
                this.$axios.post('website-info/rights.php' , {} , {
                    headers: generateHeader("websiteInfoRights")
                })
                .then((response) => {
                    if(response.data.code == "200"){

                        //Whole Page rights
                        this.rights.page = response.data.body.rights.website_info_page == 1 ? true : false

                        // Rights
                        this.rights.information = response.data.body.rights.information == 1 ? true : false
                        this.rights.bankDetails = response.data.body.rights.bank_details == 1 ? true : false
                        this.rights.socialMediaURL = response.data.body.rights.social_media_url == 1 ? true : false  
                        if(this.rights.page){
                            this.getData();
                        }
                    }
                    else if(response.data.code == "403"){
                        this.$notify.info({
                            title: 'Info',
                            message: response.data.extra.message
                        });
                        this.$router.push('/admin/dashboard')
                    }
                    else if (response.data.code == "401"){
                        this.$notify.info({
                            title: 'Info',
                            message: response.data.extra.message
                        });
                        localStorage.clear()
                        this.$router.push('/login')
                    }
                    else{
                        this.$notify.info({
                            title: 'Info',
                            message: response.data.extra.message
                        });
                    }
                    this.loading = false
                })
                .catch((error) => {
                    this.$notify.error({
                        title: 'Error',
                        message: error
                    });
                    this.loading = false
                })
            },
        getData() {
            this.page.loading = true
            this.$axios.post("website-info/get.php" , {
            }, {
                headers: generateHeader("websiteInfoData")
            })
            .then((response) => {
                if(response.data.code = "200"){
                    // Data
                    this.page.form.facebookURL = response.data.body[0].value
                    this.page.form.instagramURL = response.data.body[1].value
                    this.page.form.tiwtterURL = response.data.body[2].value
                    this.page.form.youtubeURL = response.data.body[3].value

                    this.page.form.accountName = response.data.body[4].value
                    this.page.form.nameOfBank = response.data.body[5].value
                    this.page.form.branch = response.data.body[6].value
                    this.page.form.accountNummber = response.data.body[7].value
                    this.page.form.ifsc = response.data.body[8].value

                    this.page.form.address1 = response.data.body[9].value
                    this.page.form.address2 = response.data.body[10].value
                    this.page.form.mapURL = response.data.body[11].value
                    this.page.form.mobile1 = response.data.body[12].value
                    this.page.form.mobile2 = response.data.body[13].value
                    this.page.form.email1 = response.data.body[14].value
                    this.page.form.email2 = response.data.body[15].value
                }
                else if (response.data.code == "401"){
                    this.$notify.info({
                        title: 'Info',
                        message: response.data.extra.message
                    });
                    localStorage.clear()
                    this.$router.push('/login')
                }
                else{
                    this.$notify.info({
                        title: 'Info',
                        message: response.data.extra.message
                    });
                }
                this.page.loading = false
            })
            .catch((error) => {
                this.$notify.error({
                    title: 'Error',
                    message: error                       
                });
                this.page.loading = false
            })
        },
        setData() {
            this.page.updateBtnLoad = true
            var data = this.page.form
            this.$axios.post("website-info/set.php" , {
                data                
            }, {
                headers: generateHeader("setWebsiteInfoData")
            })
            .then((response) => {
                if(response.data.code == "204"){
                    this.$notify.success({
                        title: 'Success',
                        message: response.data.extra.message
                    });
                    this.getData()
                }
                else if (response.data.code == "401"){
                    this.$notify.info({
                        title: 'Info',
                        message: response.data.extra.message
                    });
                    localStorage.clear()
                    this.$router.push('/login')
                }
                else{
                    this.$notify.info({
                        title: 'Info',
                        message: response.data.extra.message
                    });
                }
                this.page.updateBtnLoad = false
            })
            .catch((error) => {
                this.$notify.error({
                    title: 'Error',
                    message: error                       
                });
                this.page.updateBtnLoad = false
            })
        }
    },
    mounted() {
        // this.getData()
        this.getRights()
    }
}
</script>